import { webVitalsLog } from 'components/Debug';
import { isNoticiesPath, isEsadirPath, is3catPath } from 'utils/pathHelper';
import 'styles/globals.scss';
//import 'styles/noticies/globals.scss';
import 'the-new-css-reset/css/reset.css';
import App3cat from './3cat/app3cat';
import App3catinfo from './3catinfo/app3catinfo';
import Appesadir from './esadir/appesadir';
import AppCorporatiu from './corporatiu/appCorporatiu';

function MyApp({ Component, pageProps, router }) {
    if (pageProps?.errorCode) {
        throw Error(pageProps.errorCode);
    }
    if (pageProps?.error) {
        throw Error(pageProps.error.message || 'Internal Server Error');
    }

    // Evitem errors al prerender del build de la pipe
    if (
        router.pathname === '/3cat/app3cat' ||
        router.pathname === '/3catinfo/app3catinfo' ||
        router.pathname === '/esadir/appesadir' ||
        router.pathname === '/corporatiu/appCorporatiu'
    ) {
        return null;
    }

    const isNoticies = isNoticiesPath(router.asPath);
    const isEsadir = isEsadirPath(router.asPath);
    const is3cat = is3catPath(router.asPath);

    if (isNoticies) {
        return <App3catinfo Component={Component} pageProps={pageProps} router={router} />;
    } else if (isEsadir) {
        return <Appesadir Component={Component} pageProps={pageProps} />;
    } else if (is3cat) {
        return <App3cat Component={Component} pageProps={pageProps} />;
    } else {
        return <AppCorporatiu Component={Component} pageProps={pageProps} />;
    }
}
export default MyApp;

export function reportWebVitals(metric) {
    webVitalsLog(metric);
}
